import { DELAY } from '../const/time.const';
import debounce from 'lodash/debounce';
/**
 * Debounce method decorator - delays execution of a function until given amount of milliseconds have elapsed since the last time it was called
 * @param delay 100ms
 * @returns MethodDecorator
 * ```
 *  import { Debounce } from '@emobg/web-utils';
 * ```
 * ```@Debounce()```\
 * ```myDebouncedMethod()```

 * ```@Debounce(200)```\
 * ```myDebouncedMethod()```
*/
export function Debounce(delay = DELAY.tiny) {
    return function (_target, _propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        const debouncedlMethod = debounce(originalMethod, delay);
        descriptor.value = function (...args) {
            debouncedlMethod.apply(this, args);
        };
        return descriptor;
    };
}
